import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
import {
  CheckCircle2,
  XCircle,
  AlertTriangle,
  Info,
  Loader2,
} from "lucide-react";

// Modern toast look: a clean card with a coloured LEFT ACCENT + matching icon
// per type — success (green), error (red), warning (amber), info (blue) —
// instead of a fully saturated background.
const Toaster = ({ ...props }) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CheckCircle2 className="h-5 w-5 text-emerald-500" />,
        error: <XCircle className="h-5 w-5 text-rose-500" />,
        warning: <AlertTriangle className="h-5 w-5 text-amber-500" />,
        info: <Info className="h-5 w-5 text-blue-500" />,
        loading: <Loader2 className="h-5 w-5 animate-spin text-slate-400" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white dark:group-[.toaster]:bg-slate-900 " +
            "group-[.toaster]:text-slate-900 dark:group-[.toaster]:text-slate-100 " +
            "group-[.toaster]:border group-[.toaster]:border-slate-200 dark:group-[.toaster]:border-slate-800 " +
            "group-[.toaster]:rounded-2xl group-[.toaster]:shadow-xl group-[.toaster]:gap-3 " +
            "group-[.toaster]:border-l-4",
          title: "group-[.toast]:font-semibold group-[.toast]:text-sm",
          description:
            "group-[.toast]:!text-slate-600 dark:group-[.toast]:!text-slate-300 group-[.toast]:text-xs",
          actionButton:
            "group-[.toast]:bg-slate-900 dark:group-[.toast]:bg-white group-[.toast]:text-white dark:group-[.toast]:text-slate-900 group-[.toast]:rounded-lg",
          cancelButton:
            "group-[.toast]:bg-slate-100 dark:group-[.toast]:bg-slate-800 group-[.toast]:text-slate-600 dark:group-[.toast]:text-slate-300 group-[.toast]:rounded-lg",
          closeButton:
            "group-[.toast]:border-slate-200 dark:group-[.toast]:border-slate-700",
          // Left-accent colour per type.
          success: "group-[.toaster]:!border-l-emerald-500",
          error: "group-[.toaster]:!border-l-rose-500",
          warning: "group-[.toaster]:!border-l-amber-500",
          info: "group-[.toaster]:!border-l-blue-500",
          default: "group-[.toaster]:!border-l-blue-500",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
